import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Cover from "@/pages/Cover";
import Collection from "@/pages/Collection";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Cover />} />
          <Route path="/collection" element={<Collection />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
